
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(event) {
      const newValue = event.target.checked;
      this.$emit("change", { name: this.name, value: newValue });
    }
  }
};
